// extracted by mini-css-extract-plugin
export var md = "_6b-4";
export var semantic = "_6b-5";
export var sm = "_6b-3";
export var text = "_6b-6";
export var toggleInput = "_6b-0";
export var toggleSwitch = "_6b-1";
export var xs = "_6b-2";